import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import BryxDumbSearchBar from "./BryxDumbSearchBar";
import BryxButton from "../BryxButton";
import BryxIcon from "../BryxIcon/BryxIcon";
import BryxColors from "../../types/theme";
const BryxCollapsibleDumbSearchBar = styled((props) => (_jsxs("div", { className: props.className + " " + (!!props.expanded ? "active" : ""), children: [_jsx(BryxButton, { variant: "outlined", children: _jsx(BryxIcon, { iconName: "search", smIconSize: true }) }), _jsx(BryxDumbSearchBar, { value: props.value, onChange: props.onChange, onClear: props.onClear, placeholder: props.placeholder ?? "Search..." })] })))(({ theme }) => {
    return {
        "&": {
            position: "relative",
            width: "34px",
            height: "34px",
            margin: "0px",
            "& input[type=text]::placeholder": {
                opacity: 1,
            },
            "&, & *": {
                transition: `
                    width 250ms,
                    opacity 250ms,
                    z-index 0ms 250ms,
                    padding 250ms
                `,
            },
            "& > button": {
                position: "absolute",
                width: "100%",
                height: "100%",
                padding: "0px",
                opacity: 1,
                zIndex: 1,
                minWidth: "0px",
                transition: `
                    background-color 250ms cubic-bezier(0.4, 0, 0.2, 1),
                    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1),
                    border-color 250ms cubic-bezier(0.4, 0, 0.2, 1),
                    color 250ms cubic-bezier(0.4, 0, 0.2, 1),
                    width 250ms,
                    opacity 250ms,
                    z-index 0ms 250ms,
                    padding 250ms
                `,
                justifyContent: "start",
                paddingLeft: "8px",
            },
            "& div": {
                "&": {
                    position: "absolute",
                    zIndex: 0,
                    opacity: 0,
                },
            },
            "&:not(.active) div": {
                width: "32px !important",
            },
            "&.active": {
                width: "243px",
                "& > button": {
                    opacity: 0,
                    zIndex: 0,
                    borderColor: BryxColors.LightMode.specialColors.searchBarBackground,
                    // keep icon in place
                    justifyContent: "left",
                    paddingLeft: "16px",
                },
                "& div": {
                    backgroundColor: "none",
                    opacity: 1,
                    zIndex: 1,
                },
            },
        },
    };
});
export default BryxCollapsibleDumbSearchBar;
